import { computed, unref } from 'vue'
import {
  USER_PRIVACY_EVERYONE_NO_COMMENTS,
  USER_PRIVACY_SUBSCRIBERS,
  USER_PRIVACY_EVERYONE,
} from '@config/options.js'
import {
  userSubscriptionStore,
  subscriptionStore,
  userStore,
  gameStore,
  authStore,
} from '@stores'

const UPPERCASE_UGC_NAMES = ['UGC', 'UGX']

export default function () {
  const { user: myUser } = authStore()
  const { getPublicGame } = gameStore()
  const { getUser } = userStore()

  const { hasSubscriptionForUser: hasSubscribedToMod } = subscriptionStore()
  const { hasSubscriptionForUser: hasSubscribedToUser } =
    userSubscriptionStore()

  function canViewUserProfile(userNameId) {
    return computed(() => {
      const user = getUser(userNameId)

      return (
        myUser.value?.name_id === userNameId ||
        user.value?.privacy_options === USER_PRIVACY_EVERYONE ||
        user.value?.privacy_options === USER_PRIVACY_EVERYONE_NO_COMMENTS ||
        (user.value?.privacy_options === USER_PRIVACY_SUBSCRIBERS &&
          (hasSubscribedToUser(userNameId).value ||
            hasSubscribedToMod(userNameId).value))
      )
    })
  }

  function ugcName(game, singular, lower) {
    return computed(() => {
      let _game = unref(game)

      if (!_game) {
        _game = getPublicGame().value
      }

      let _ugcName = _game?.ugc_name || 'Mods'
      if (singular) {
        _ugcName = _game?.ugc_name_single || _ugcName.replace(/s$/, '')
      }

      if (lower && !UPPERCASE_UGC_NAMES.includes(_ugcName)) {
        _ugcName = _ugcName.toLowerCase()
      }

      return _ugcName
    })
  }

  return {
    canViewUserProfile,
    ugcName,
  }
}
